import React, { useState } from 'react';
import { Project } from 'data/terra/Project';
import './ProjectIcon.scss';
import DefaultProjectIcon from 'v2/components/project/DefaultProjectIcon';
import { CheckActiveIcon, CheckInactiveIcon } from 'v2/containers/Icons';

interface ProjectIconProps {
  project: Project | undefined | null;
  checked: boolean;
  style?: object;
  textStyle?: object;
  onClick: (project: Project) => void;
}

const ProjectIcon: React.FC<ProjectIconProps> = props => {
  const [isHover, setIsHover] = useState(false);
  return (
    <div
      className="project-icon-name-container"
      style={props.style}
      onClick={() => {
        if (props.project) props.onClick(props.project);
      }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {props.project?.logoUrl ? (
        <img src={props.project?.logoUrl} alt="logo" width={32} height={32} className='bordered-image'/>
      ) : (
        <div className="project-icon-default-icon">
          <DefaultProjectIcon projectName={props.project?.projectName ?? ''} />
        </div>
      )}
      <span className="project-icon-name ds-typo-subtitle2" style={props.textStyle}>
        {props.project?.projectName}
      </span>
      <div style={{ flex: 1 }} />
      {props.checked && CheckActiveIcon}
      {!props.checked && isHover && CheckInactiveIcon}
    </div>
  );
};

export default ProjectIcon;
